<template>
  <div class="animated fadeI">
    <el-card class="box-card mb-3">
      <div class="employee-contract__list">
        <p class="mb-2">Danh sách hợp đồng lao động</p>
        <el-table
          :data="mData.dataDefault.listEmployeeContracts"
          border
          style="width: 100%"
        >
          <el-table-column
            label="STT"
            align="center"
            width="50"
          >
            <template slot-scope="scope">
              <div class="text-center">
                {{ scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Tên hợp đồng"
            width="260"
          >
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                trigger="hover"
                :open-delay="800"
                :content="scope.row.name"
              >
                <span class="content" slot="reference">{{
                  scope.row.name
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="code"
            label="Số hợp đồng"
            align="center"
            min-width="150"
          >
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              trigger="hover"
              :open-delay="800"
              :content="scope.row.code"
            >
              <span class="content" slot="reference">{{
                scope.row.code
              }}</span>
            </el-popover>
          </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="Ngày hiệu lực"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              {{
                formatDate(scope.row.effective_date || "")
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="Ngày hết hiệu lực"
            align="center"
            width="140"
          >
            <template slot-scope="scope">
              {{
                formatDate(scope.row.expiration_date || "")
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="Thao tác"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                plain
                round
                @click="handle('detail', scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="isax-eye"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="employee-document__list mt-5">
        <p class="mb-2">Danh sách văn bản</p>
        <el-table
          :data="mData.dataDefault.listEmployeeDocuments"
          border
          style="width: 100%"
        >
          <el-table-column
            label="STT"
            align="center"
            width="50"
          >
            <template slot-scope="scope">
              <div class="text-center">
                {{ scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Tên văn bản"
            min-width="220"
          >
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              trigger="hover"
              :open-delay="800"
              :content="scope.row.name"
            >
              <span class="content" slot="reference">{{
                scope.row.name
              }}</span>
            </el-popover>
          </template>
          </el-table-column>
          <el-table-column
            prop="description"
            label="Ghi chú"
            min-width="260"
          >
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                trigger="hover"
                :open-delay="800"
                :content="scope.row.description"
              >
                <span class="content" slot="reference">{{
                  scope.row.description
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            label="Thao tác"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                plain
                round
                @click="handle('detail', scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="isax-eye"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <el-dialog
      title="Xem thông tin"
      :visible.sync="mData.visibleDialog"
      top="50px"
      width="710px"
      :before-close="handleClose"
      class="form-dialog"
    >
      <div class="form">
        <el-form
          ref="myForm"
          :model="mData.dataForm"
          :rules="mData.validForm"
          label-position="left"
          label-width="160px"
        >
          <b-row>
            <b-col md="12">
              <el-form-item label="Loại văn bản" prop="type">
                <el-select
                  v-model="mData.dataForm.type"
                  disabled
                  clearable
                  placeholder="Chọn"
                >
                  <el-option
                    v-for="(item,index) in mData.dataDefault.listTypes"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Tên văn bản" prop="name">
                <el-input
                  type="textarea"
                  v-model="mData.dataForm.name"
                  disabled
                  :autosize="{ minRows: 2, maxRows: 6}"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Số văn bản" prop="code" v-if="mData.dataForm.type == 'CONTRACT'">
                <el-input
                  v-model="mData.dataForm.code"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Ngày hiệu lực" prop="effective_date" v-if="mData.dataForm.type == 'CONTRACT'">
                <el-date-picker
                  type="date"
                  ref="EffectiveDate"
                  v-model="mData.dataForm.effective_date"
                  disabled
                  :clearable="false"
                  placeholder=""
                  prefix-icon="isax-calendar-1"
                  :format="'dd/MM/yyyy'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Ngày hết hiệu lực" prop="expiration_date" v-if="mData.dataForm.type == 'CONTRACT'">
                <el-date-picker
                  type="date"
                  ref="ExpirationDate"
                  v-model="mData.dataForm.expiration_date"
                  disabled
                  :clearable="false"
                  placeholder=""
                  prefix-icon="isax-calendar-1"
                  :format="'dd/MM/yyyy'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Ghi chú" prop="description">
                <el-input
                  type="textarea"
                  v-model="mData.dataForm.description"
                  disabled
                  :autosize="{ minRows: 2, maxRows: 6}"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Tệp" prop="file_ids">
                <el-upload
                  ref="upload"
                  :auto-upload="false"
                  list-type="text"
                  drag
                  action
                  :on-preview="previewFile"
                  :file-list="mData.fileList"
                  disabled
                  multiple
                  class="hide"
                >
                </el-upload>
              </el-form-item>
            </b-col>
          </b-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer text-center">
        <el-button
          @click="handleClose"
        >
          Đóng
        </el-button>
        <el-button v-if="mData.dataForm.file_ids.length > 1" @click="downloadZipFile(mData.dataForm)">
          Tải File
        </el-button>
      </div>
    </el-dialog>
    <!-- Dialog xem chi tiết file -->
    <el-dialog
      title=""
      :visible.sync="visibleDialogFile"
      width="width"
      :before-close="dialogBeforeClose"
    >
      <div>

        <iframe
          v-if="mData.typeFile == 'file'"
          id="iframe1"
          class="iframe"
          style="width: 100%; height: 76vh; border: none; font-size: 17px"
          :src="mData.urlShowFile"
        >
          <p>Trình duyệt của bạn không hỗ trợ iframe.</p>
        </iframe>

      </div>
      <div slot="footer">
        <el-button @click="visibleDialogFile = false">
          Đóng
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DataService from "../../service/DataService";
import MethodService from "../../service/MethodService";
import ExtensionService from "../../service/ExtensionService";
import LanguageService from '../../service/LanguageService';
import EmployeeModel from '@/views/admin/Employees/EmployeeModel';
import FileApi from '../../moduleApi/FileApi';
import EmployeeApi from '../../moduleApi/EmployeeApi';
import EmployeeContractApi from '../../moduleApi/EmployeeContractApi';
import EventBus from '../../service/EventBus';

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      visibleDialogFile: false,
      mData: {
        dataForm: MethodService.copyObject(EmployeeModel.dataFormEmployeeContract),
        fileList: [],
        employeeId: undefined,
        urlShowFile: undefined,
        typeFile: undefined,
        dataDefault: {
          listEmployees: [],
          listTypes: DataService.listTypeContractOrDocument,
          listEmployeeContracts: [],
          listEmployeeDocuments: [],
          listTypeFileImg: [".jpg",'.jpeg','.png']
        },
      }
    };
  },
  methods: {
    async initDataDefault(){
      try {
        const employeeApiReq = EmployeeApi.list({
          filters: "status!=DA_NGHI",
          limit: 9999999,
          sort: "administrative_info.name.first_name"
        });
        await Promise.all([
          employeeApiReq
        ]).then((promiseValue) => {
          this.mData.dataDefault.listEmployees = promiseValue[0].result;
        })
      } catch (error) {

      }
    },
    async initData(){
      if (!this.$router.currentRoute.params.id) return
      this.mData.employeeId = this.$router.currentRoute.params.id;
      const employeeContractApiRes = await EmployeeContractApi.list({
        filters: `employee_id=${this.mData.employeeId}`
      })
      this.mData.dataDefault.listEmployeeContracts = this.filterDataTable(employeeContractApiRes.result, "CONTRACT");
      this.mData.dataDefault.listEmployeeDocuments = this.filterDataTable(employeeContractApiRes.result, "DOCUMENT");
    },
    filterDataTable(dataList, type){
      return dataList.filter(item => item.type == type);
    },
    handleClose(){
      this.mData.visibleDialog = false;
      this.resetForm();
    },
    resetForm(){
      this.mData.fileList = [];
    },
    previewFile(file){
      window.open(ExtensionService.urlDowloadFile + file.id);
    },
    async handle(type, row){
      if (type == "detail") {
        this.mData.visibleDialog = true;
        this.mData.dataForm = row;
        if (!this.mData.dataForm.file_ids) this.mData.fileList = []
        let listFile = await FileApi.list({
          limit: this.mData.dataForm.file_ids.length,
          filters: "id:in:" + this.mData.dataForm.file_ids.join(","),
        });
        this.mData.fileList = listFile.result.map(file => {
          file.url = ExtensionService.urlImg + file.id;
          return file;
        })
      }
    },
    formatDate(date) {
      return MethodService.formatDate(date, "date");
    },
    dialogBeforeClose(){
      this.visibleDialogFile = false;
      this.mData.typeFile = undefined;
      this.mData.urlShowFile = undefined;
    },
    downloadZipFile(data){
      ExtensionService.zipFile(data.file_ids, `${data.type == "CONTRACT" ? "HopDong" : "VanBan"}_${this.getEmployeeCode(data.employee_id)}`);
    },
    getEmployeeCode(id){
      let employee = this.mData.dataDefault.listEmployees.find(em => em.id == id);
      if (!employee) return
      return employee.employee_no
    },
  },
  created() {
    this.initDataDefault();
    this.initData();
    EventBus.$off("click_HopDong");
    EventBus.$off("rowClick_HopDong");
    EventBus.$off("tab_HopDong");

    EventBus.$on("click_HopDong", () => {
      this.initData();
    });
    EventBus.$on("rowClick_HopDong", () => {
      this.initData();
    });
    EventBus.$on("tab_HopDong", () => {
      this.initData();
    });
  }
}
</script>

<style scoped>
  p{
    margin-bottom: 0;
  }
  ::v-deep .el-upload-list__item-status-label{
    display: none !important;
  }
</style>
